import React, { useState } from 'react';
import {
  callBundleListingSMS,
  deleteBundleComplete,
  getAllProviderCall,
  getAllProviderSMS,
} from '../../api-services';
import { Dropdown } from 'react-bootstrap';
import AddBundle from './AddBundle';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEllipsisV,
  faEdit,
  faTrash,
} from '@fortawesome/free-solid-svg-icons';
import Country from '../../components/Country';
import { createTable } from '@tanstack/react-table';
import TableManager from '../../components/TableManager';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { Country as GlobalCountries } from 'country-state-city';
import swal from 'sweetalert';

const table = createTable();

const bundleTypesOptions = [
  { label: 'CALL', value: 'CALL' },
  { label: 'SMS', value: 'SMS' },
  { label: 'VN', value: 'VN' },
];

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const initialValues = {
  filter: [
    {
      country: '',
      a_filter_type: '',
      placeholder: 'Select Country...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: GlobalCountries?.getAllCountries(),
      label: 'Country',
    },

    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};

const BundleSMS = () => {
  const [editData, setEditData] = useState({});
  const [addBundle, setAddBundle] = useState(false);
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const queryClient = useQueryClient();
  const { data: AllProvidersCall } = useQuery(
    'getAllProviderCall',
    getAllProviderCall,
    {
      select: (data) => data?.data?.data ?? [],
    },
  );
  const { data: AllProvidersSMS } = useQuery(
    'getAllProviderSMS',
    getAllProviderSMS,
    {
      select: (data) => data?.data?.data ?? [],
    },
  );

  const { isLoading: isLoadingDeleteBundle, mutateAsync: mutateAsync1 } =
    useMutation('deleteBundleComplete', deleteBundleComplete, {
      onSuccess: (data) => {
        swal({
          text: data?.data?.message,
          icon: 'success',
          type: 'success',
          timer: 3000,
        }).then(() => {
          queryClient.invalidateQueries('bundleListing');
          queryClient.invalidateQueries('callBundleListingSMS');
          queryClient.invalidateQueries('callBundleListingVN');
          queryClient.invalidateQueries('callBundleListingCALL');
        });
      },
      onError: (error) => {
        swal({
          type: 'danger',
          text: error?.response?.data?.message,
          icon: 'error',
          timer: 3000,
        });
      },
    });

  const handleEditData = (data) => {
    // return false;
    setEditData(data);
    setAddBundle(true);
  };

  const handleAddBundle = () => {
    setAddBundle(true);
  };

  const handleDeleteBundle = async ({ bundle_unicode }) => {
    swal({
      text: 'Are you sure you want to delete this Bundle ?',
      buttons: true,
      icon: 'warning',
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          await mutateAsync1(bundle_unicode);
        } catch (error) {
          console.log(error);
        }
      }
    });
  };

  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
      isSortable: true,
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD: HH:mm:ss'),
    }),

    table.createDataColumn((row) => row?.countries?.alpha2code, {
      id: 'country',
      header: 'Country',
      textAlign: 'left',
      cell: (props) => <Country isoCode={props.getValue()} />,
    }),
    table.createDataColumn('period', {
      id: 'period',
      header: 'Period ( Month )',
      isSortable: true,
    }),
    table.createDataColumn('bundle_type', {
      id: 'bundle_type',
      header: 'Type',
    }),
    table.createDataColumn(
      (row) => {
        const bundle = `${row?.bundle} ${
          row?.bundle_type === 'CALL' ? 'mins' : 'SMS'
        }`;
        return bundle;
      },
      {
        id: 'bundle',
        header: 'Bundle',
        isSortable: true,
      },
    ),
    table.createDataColumn('rates', {
      id: 'rates',
      header: 'Rate(s)',
      textAlign: 'left',
      cell: (props) => {
        return (
          props.getValue()?.length > 0 &&
          props.getValue().map(({ currency, cost }) => {
            return (
              <div className="btn btn-primary mr-10 btn-sm">
                <label className="labelMove mb-0">{`${currency}:`}</label>
                &nbsp;<label className="mb-0">{cost}</label>
              </div>
            );
          })
        );
      },
    }),

    table.createDisplayColumn({
      id: 'action',
      header: 'Action',
      textAlign: 'center',
      cell: (props) => (
        <span>
          <Dropdown className="dropdown_dot mx-auto">
            <Dropdown.Toggle
              id="dropdown-basic"
              className="btn-light-blue btn-action "
            >
              <FontAwesomeIcon icon={faEllipsisV} />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleEditData(props.row.original)}
              >
                <FontAwesomeIcon icon={faEdit} /> Edit
              </Dropdown.Item>
              <Dropdown.Item
                href={void 0}
                onClick={() => handleDeleteBundle(props.row.original)}
              >
                <FontAwesomeIcon icon={faTrash} />
                Delete
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </span>
      ),
    }),
  ];

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        cta={true}
        ctaFunction={handleAddBundle}
        ctaLabel="Add Bundle"
        fetcherKey="callBundleListingSMS"
        fetcherFn={callBundleListingSMS}
        title="SMS Bundles / Plans"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
      />

      {addBundle && (
        <AddBundle
          type="Sms"
          setOpenModal={setAddBundle}
          openModal={addBundle}
          editData={editData}
          AllProvidersCall={AllProvidersCall}
          AllProvidersSMS={AllProvidersSMS}
          setEditData={setEditData}
        />
      )}
    </>
  );
};

export default BundleSMS;
